<template>
  <div v-if="postShow">
    <v-dialog
      v-model="advertRemoveDialog"
      max-width="406"
      flat
      elevation="0"
      persistent
    >
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
        <v-card-title
          class="justify-center pb-0 mb-0 defaultColor--text text-center"
          style="word-break: break-word"
        >
          {{ $t("description.removeAdvert") }}
        </v-card-title>
        <v-card-actions class="justify-center align-center d-flex mt-4">
          <v-btn
            color="greenColor"
            class="white--text text-capitalize"
            width="150"
            elevation="0"
            rounded
            large
            :loading="deleteButtonLoading"
            @click="removeAdvert()"
          >
            {{ $t("buttons.yes") }}
          </v-btn>
          <v-btn
            color="greyColor"
            class="white--text text-capitalize ml-3 ml-0"
            width="150"
            elevation="0"
            rounded
            large
            @click="advertRemoveDialog = false"
          >
            {{ $t("buttons.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="advertRemoveDialog = false" />
    </v-dialog>

    <v-dialog
      v-model="advertEditDialog"
      max-width="406"
      flat
      elevation="0"
      persistent
    >
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
        <v-card-title
          class="justify-center pb-0 mb-0 defaultColor--text text-center"
          style="word-break: break-word"
        >
          {{ $t("description.editAdvert") }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="title"
            outlined
            color="default-Color"
            hide-details
            single-line
            full-width
            :label="$t('labels.advertTitle')"
            class="mb-5"
          >
          </v-text-field>
          <v-text-field
            v-model.trim="price"
            outlined
            color="default-Color"
            hide-details
            single-line
            full-width
            :label="$t('labels.advertPrice')"
          >
          </v-text-field>
          <v-text-field
            class="pt-5"
            v-model.trim="city"
            outlined
            color="default-Color"
            hide-details
            single-line
            full-width
            :label="$t('labels.advertCity')"
          >
          </v-text-field>
          <v-textarea
            class="pt-5"
            outlined
            v-model.trim="content"
            full-width
            color="purple"
            :label="$t('labels.advertDescription')"
            :counter="contentCounter"
            rows="4"
          ></v-textarea>
          <v-textarea
            class="pt-2"
            outlined
            v-model.trim="contact"
            full-width
            color="purple"
            :label="$t('labels.advertContactInformation')"
            :counter="contactCounter"
            rows="3"
          >
            <template v-slot:append>
              <v-tooltip bottom max-width="400" color="defaultColorLight">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    depressed
                    width="20"
                    height="20"
                    dark
                    small
                    color="defaultColor"
                  >
                    <v-icon dark size="12"> mdi-help </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("description.advertContactInfo") }}</span>
              </v-tooltip>
            </template>
          </v-textarea>
        </v-card-text>

        <v-card-actions class="justify-center align-center d-flex mt-4">
          <v-btn
            color="greenColor"
            class="white--text text-capitalize"
            width="150"
            elevation="0"
            rounded
            large
            :loading="editButtonLoading"
            @click="editAdvert()"
          >
            {{ $t("buttons.edit") }}
          </v-btn>
          <v-btn
            color="greyColor"
            class="white--text text-capitalize ml-3 ml-0"
            width="150"
            elevation="0"
            rounded
            large
            @click="
              advertEditDialog = false;
              clearModal();
            "
          >
            {{ $t("buttons.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button
        @clickButton="
          advertEditDialog = false;
          clearModal();
        "
      />
    </v-dialog>

    <v-dialog
      v-model="ownerDialogShow"
      max-width="406"
      flat
      elevation="0"
      persistent
    >
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
        <v-card-title class="justify-center pb-0 mb-0 defaultColor--text">
          {{ $t("title.advertOwnerInfo") }}
        </v-card-title>
        <v-card-actions class="justify-center align-center mt-4">
          <h3>
            {{ getContact }}
          </h3>
        </v-card-actions>
        <v-card-actions class="justify-center align-center pb-5 mt-0">
          <h3>
            {{ postItem.User.FullName }}
          </h3>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="ownerDialogShow = false" />
    </v-dialog>

    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <!-- Feeds-->
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mb-10 mt-10">
                <v-card
                  flat
                  color="greyColorLigthThree"
                  class="px-5"
                  v-if="postShow"
                >
                  <!-- Content Detail -->
                  <v-layout fill-height row wrap mx-4 mb-3>
                    <v-layout
                      column
                      wrap
                      class="overflow-x-hidden pr-3 mt-0"
                      style="line-height: 20px; word-wrap: break-word"
                    >
                      <h3
                        style="font-size: 22px"
                        :class="`defaultColor--text font-weight-bold mb-3`"
                      >
                        {{ postItem.Title }}
                      </h3>
                      <h3
                        style="
                          font-size: 16px;
                          overflow-y: hidden;
                          margin-bottom: 10px;
                        "
                        :class="`defaultColor--text font-weight-medium `"
                      >
                        {{ getCity }}
                      </h3>
                      <h4
                        style="font-size: 16px; overflow-y: hidden"
                        :class="`defaultColor--text font-weight-medium `"
                        v-html="postItem.Content"
                        v-linkified
                      ></h4>
                      <h4
                        style="font-size: 15px"
                        :class="`priceStyle defaultColorLight--text mt-3`"
                      >
                        {{ getPrice }}
                      </h4>
                    </v-layout>
                    <v-spacer />

                    <div class="dateStyle d-flex flex-column text-center">
                      {{ moment(postItem.CreatedAt).locale("tr").fromNow() }}
                      <v-btn
                        color="defaultColor"
                        class="white--text text-capitalize mr-0 elevation-0 mt-4"
                        rounded
                        @click="buttonClick()"
                      >
                        {{ buttonText }}
                      </v-btn>
                      <v-btn
                        v-if="postItem.UserId == $store.state.userId"
                        color="defaultColor"
                        class="white--text text-capitalize mr-0 elevation-0 mt-4"
                        rounded
                        @click="buttonClick(true)"
                      >
                        {{ "İlanı Düzenle" }}
                      </v-btn>
                    </div>
                  </v-layout>
                  <!-- Media -->
                  <div v-if="postItem.ParentPost == null" class="py-5">
                    <feed-item-media
                      :itemData="postItem"
                      :academyPost="false"
                    />
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";
import PostService from "../../services/PostService";
import FeedItemMedia from "../../components/Feeds/FeedItemMedia.vue";
import DialogCloseButton from "../../components/General/DialogCloseButton.vue";
export default {
  data: () => {
    return {
      postId: "",
      postItem: {},
      postShow: false,
      ownerDialogShow: false,
      advertRemoveDialog: false,
      advertEditDialog: false,
      deleteButtonLoading: false,
      editButtonLoading: false,
      contactCounter: 10,
      contentCounter: 250,
      price: "",
      title: "",
      content: "",
      contact: "",
      city: "",
    };
  },
  components: {
    FeedItemCard,
    FeedItemMedia,
    DialogCloseButton,
  },
  methods: {
    getFeedItems() {
      setPageLoading(true);
      PostService.getPostDetail(this.postId)
        .then((res) => {
          if (res.data.Data) {
            this.postShow = true;
            this.postItem = res.data.Data[0];
            this.title = this.postItem.Title;
            this.content = this.postItem.Content;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          setPageLoading(false);
        });
    },

    buttonClick(isEdit = false) {
      if (this.postItem.UserId === this.$store.state.userId) {
        if (isEdit) {
          this.title = this.postItem.Title;
          this.content = this.postItem.Content;
          this.city =
            this.postItem.Properties[
              this.postItem.Properties.findIndex((x) => x.Key === "sehir")
            ].Value;
          this.price =
            this.postItem.Properties[
              this.postItem.Properties.findIndex((x) => x.Key === "fiyat")
            ].Value;
          this.contact =
            this.postItem.Properties[
              this.postItem.Properties.findIndex(
                (x) => x.Key === "iletisim_bilgisi"
              )
            ].Value;
          this.advertEditDialog = true;
        } else {
          this.advertRemoveDialog = true;
        }
      } else {
        this.ownerDialogShow = true;
      }
    },

    removeAdvert() {
      this.deleteButtonLoading = true;
      PostService.deletePost(this.postItem.Id)
        .then((res) => {
          showSuccess(this.$t("description.successDeleteContent"));
          this.advertRemoveDialog = false;
          this.$router.push("/adverts");
        })
        .catch(async (err) => {
          showError(err);
        })
        .then(() => {
          this.advertRemoveDialog = false;
          this.deleteButtonLoading = false;
        });
    },

    editAdvert() {
      this.editButtonLoading = true;
      this.postItem.Title = this.title;
      this.postItem.Content = this.content;
      this.postItem.Properties[
        this.postItem.Properties.findIndex((x) => x.Key === "sehir")
      ].Value = this.city;
      this.postItem.Properties[
        this.postItem.Properties.findIndex((x) => x.Key === "fiyat")
      ].Value = this.price;
      this.postItem.Properties[
        this.postItem.Properties.findIndex((x) => x.Key === "iletisim_bilgisi")
      ].Value = this.contact;
      console.log("POST EDIT >> ", this.postItem);
      PostService.updatePost(this.postItem)
        .then((res) => {
          showSuccess(this.$t("description.successEditContent"));
          this.advertEditDialog = false;
          this.$router.push("/adverts");
        })
        .catch(async (err) => {
          showError(err);
        })
        .then(() => {
          this.advertEditDialog = false;
          this.editButtonLoading = false;
        });
    },

    clearModal() {
      this.title = "";
      this.content = "";
      this.contact = "";
      this.price = "";
      this.city = "";
    },
  },
  computed: {
    getCity() {
      if (this.postItem.Properties.length > 0) {
        let city = this.postItem.Properties.filter((x) => x.Key === "sehir");
        if (city.length > 0) return city[0].Value;
        else return "";
      } else {
        return "";
      }
    },

    getPrice() {
      if (this.postItem.Properties.length > 0) {
        let price = this.postItem.Properties.filter((x) => x.Key === "fiyat");
        if (price.length > 0) return price[0].Value + " TL";
        else return "";
      } else {
        return "";
      }
    },

    getContact() {
      if (this.postShow && this.postItem.Properties.length > 0) {
        let contact = this.postItem.Properties.filter(
          (x) => x.Key === "iletisim_bilgisi"
        );
        if (contact.length > 0) return contact[0].Value;
        else return "";
      } else {
        return "";
      }
    },

    buttonText() {
      if (this.postItem.UserId === this.$store.state.userId) {
        return "Yayından Kaldır";
      } else {
        return "İlgileniyorum";
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    if (this.$route.params.id) {
      this.postId = this.$route.params.id;
      this.getFeedItems();
    } else {
      this.getFeedItems();
    }
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {},
};
</script>

<style>
.word-wrap {
  word-break: break-word !important;
}

.priceStyle {
  font-weight: 700;
}

.dateStyle {
  font-size: 12px;
}
</style>
